import { StyleSheet } from 'react-native';
import Theme, { Colors } from '@qnpm/q-theme';
const { responsive: { scale } } = Theme;
const { scenes: { selectColors } } = Colors;
export const BorderStyle = {
    normal: {
        borderColor: selectColors.silverBorder,
        borderWidth: StyleSheet.hairlineWidth
    },
    selected: {
        borderColor: selectColors.brandText,
        borderWidth: StyleSheet.hairlineWidth
    }
};
export function getStyles(needScale) {
    return {
        /** 基础类型样式 */
        base: {
            /** 组件样式 */
            component: {
                width: '100%'
            },
            /** item Container样式 */
            wrapper: {
                flexDirection: 'column',
                width: '100%',
                paddingLeft: scale(15, needScale)
            },
            /** 文本内容+icon wrapper样式 */
            textWrapper: {
                flexDirection: 'row',
                alignItems: 'center',
                paddingRight: scale(12, needScale),
                paddingVertical: scale(10, needScale),
                width: '100%'
            },
            /** 文本样式 */
            text: {
                /** 文本未选中样式 */
                normal: {
                    flex: 1,
                    color: selectColors.text
                },
                /** 文本选中样式 */
                selected: {
                    flex: 1,
                    color: selectColors.brandText
                },
                /** 文本不可点击样式 */
                disable: {
                    color: selectColors.disableText,
                    backgroundColor: 'transparent'
                }
            },
            /** 图标样式 */
            icon: {
                marginLeft: scale(40),
                color: selectColors.brandText
            },
            /** 分割线样式 */
            line: {
                width: '100%',
                height: StyleSheet.hairlineWidth,
                backgroundColor: selectColors.line
            }
        },
        /** 标签样式 */
        label: {
            /** 组件样式 */
            component: {
                flex: 1,
                width: '100%',
                height: '100%'
            },
            /** item Container样式 */
            wrapper: {
                flexDirection: 'row',
                flexWrap: 'wrap',
                paddingBottom: scale(10, needScale),
                paddingHorizontal: scale(10, needScale)
            },
            /** 文本Container样式 */
            textWrapper: {
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: selectColors.silverBackgroud,
                paddingHorizontal: scale(4, needScale)
            },
            /**文本样式 */
            text: {
                /** 文本未选中样式 */
                normal: {
                    color: selectColors.text,
                    backgroundColor: 'transparent'
                },
                /** 文本选中样式 */
                selected: {
                    color: selectColors.brandText
                },
                /** 文本不可点击样式 */
                disable: {
                    color: selectColors.disableText,
                    backgroundColor: 'transparent'
                }
            },
            /** 这三个在标签样式下用不着，但是不写ESLint会报错 */
            icon: {
                normal: {},
                selected: {}
            },
            selectedIcon: {},
            line: {}
        }
    };
}
